module.exports = __webpack_public_path__ + "img/icon-arrow-up.ec7197ee.svg";